import { API } from './interceptor'

export const notifyMenuBuilderPaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  recipeTitle = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post('api2', `venue/${venueId}/menu-builder-paywall-notify`, {
    body: {
      source,
      platform,
      recipeTitle,
    },
  }).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
